import React from 'react';
import { useTranslation } from 'react-i18next';

import MenuItem from '@material-ui/core/MenuItem';
import EntityTranslationsForm from 'components/EntityTranslationsForm/EntityTranslationsForm';

import CustomInput, { Props as CustomInputProps } from '../../../../components/CustomInput/CustomInput';
import CategorySelect from '../../../PlasticAssessmentItemDetailsDialog/components/CategorySelect/CategorySelect';
import { FlexContainer } from './styled';

interface Props {
    baseInputProps: Omit<CustomInputProps, 'name'>;
    isCustomer: boolean;
    isAdmin: boolean;
    isLoading: boolean;
    adminPage?: boolean;
}

const Form = (props: Props) => {
    const { baseInputProps, isAdmin, isLoading, adminPage } = props;

    const { data, handleAttributeChange, partialTranslationKey } = baseInputProps;

    const { t } = useTranslation();

    return (
        <>
            <FlexContainer>
                <CustomInput {...baseInputProps} name='title' />

                <CategorySelect baseInputProps={baseInputProps} />

                {(isAdmin && !adminPage) && (
                    <CustomInput {...baseInputProps} name='isPublic' select booleanValues>
                        <MenuItem value={'1'} >
                            {t('dialogs.generic.flag_yes')}
                        </MenuItem>
                        <MenuItem value={'0'} >
                            {t('dialogs.generic.flag_no')}
                        </MenuItem>
                    </CustomInput>
                )}

            </FlexContainer>

            <CustomInput {...baseInputProps} name='description' rows={3} multiline />

            {(isAdmin && adminPage) && (
                <EntityTranslationsForm
                    data={data}
                    handleAttributeChange={handleAttributeChange ?? ((name: string, value: any) => undefined)}
                    partialTranslationKey={partialTranslationKey ?? ''}
                    isLoading={isLoading}
                    modelName={'good_practice'}
                />
            )}
        </>
    );
};

export default Form;
